import {Paper,Typography} from '@mui/material';
import {useKeycloak} from "@react-keycloak/web";
import {useApplication} from '../../custom/components/ApplicationContext.js';

function Footer({userData}){
  const {keycloak}=useKeycloak();
  const isLoggedIn=keycloak.authenticated;
  const {globalData}=useApplication();
  const application={globalData,getLocale:(key,options)=>globalData?.getLocale(key,options)};
  
  return (
    <>
      {isLoggedIn&&globalData&&
        <Paper sx={{textAlign:'center',zIndex:'1000',position:'fixed',bottom:0,left:0,right:0}} style={{height:'20px'}} elevation={3} square>
          <Typography sx={{pb:0,fontWeight:'200',fontSize:'0.75rem'}} variant="subtitle1">
              {globalData.list_of_values.User_Role[userData.role_name]+': '+userData.user_name+' ('+application.getLocale("FooterUser")+': '+userData.user_login+')'}
          </Typography>
        </Paper>
      }
    </>
  );
}
export default Footer;
